import { TableRow, TableCell, useMediaQuery, useTheme, Typography, TableBody, Stack, styled, Link} from '@mui/material';
import { ExpenditureItem } from '../../../types/reports/expenditureItem';


interface Props {
   tableRows?:ExpenditureItem[];
   displayFiler?: boolean;
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

const ContributionsTable = (props: Props): JSX.Element => {
    
    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    return (
            <TableBody>
                     {props.tableRows?.map((expenditure) => (
                         <StyledTableRow key={expenditure.id}>
                             <TableCell>
                                 <Typography variant={'body2'}>
                                     {expenditure.date}
                                 </Typography>
                             </TableCell>
                             {
                                (expenditure.recordTypeId ===951 || expenditure.recordTypeId === 952) &&
                                <TableCell>
                                    <Typography variant={'body2'} fontWeight={550}>
                                        {expenditure.subvendorName}
                                    </Typography>
                                    <Typography component="i"  variant="body2">
                                        {expenditure.streetAddress}
                                    </Typography>
                                </TableCell>
                             }
                             <TableCell>
                                 <Typography variant={'body2'} fontWeight={550}>
                                     {expenditure.vendor} {expenditure.vendorName}
                                 </Typography>
                                 <Typography component="i"  variant="body2" color={"primary"}>{expenditure.clarifiedName}</Typography>
                                 {
                                    expenditure.recordTypeId !=951 &&
                                    <Typography variant={'body2'} component={'i'}>
                                        {expenditure.streetAddress}
                                    </Typography>
                                 }
                             </TableCell>
                             {
                                isSM &&
                                <TableCell align='right'>
                                    <Typography variant={'body2'}>
                                        {expenditure.amount}
                                    </Typography>
                                </TableCell>
                             }
                             <TableCell>
                                 <Typography variant={'body2'}>
                                     {expenditure.city}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'body2'}>
                                     {expenditure.state}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'body2'}>
                                     {expenditure.zipCode}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                <Stack>
                                    <Typography variant="body2">{expenditure.purpose}</Typography>
                                    <Typography variant="body2" color={"primary"}><i>{expenditure.clarifiedPurpose}</i></Typography>
                                </Stack>
                             </TableCell>
                             {
                                !isSM &&
                                <TableCell align='right'>
                                    <Typography variant={'body2'}>
                                        {expenditure.amount}
                                    </Typography>
                                </TableCell>
                             }
                             {
                                props.displayFiler?
                                <TableCell>
                                    <Stack>
                                        <Typography variant="body2">
                                            <Typography component={Link} href={`/filers?q=${expenditure.filerCpfId}`} target="_blank" underline="hover" variant="body2">{expenditure.filerCpfId}</Typography> {expenditure.filerFullNameReverse}
                                        </Typography>
                                        <Typography component={Link} href={`/reports/displayreport?id=${expenditure.reportId}`} target="_blank" underline="hover" variant="body2"><i>{expenditure.sourceDescription}</i></Typography>
                                    </Stack> 
                                </TableCell>
                                :
                                <TableCell>
                                    <Typography component={Link} href={`/reports/displayreport?id=${expenditure.reportId}`} target="_blank" underline="hover" variant="body2">{expenditure.sourceDescription}</Typography>
                                </TableCell>   
                             }      
                         </StyledTableRow>
                    ))}
                 </TableBody>
    );
}

export default ContributionsTable;